import { z } from "zod";

export const PublicRequestOutputSchema = z.object({
    token: z.string().min(1),
    contractId: z.number(),
    requestDocId: z.string().nullish(),
    requestDocName: z.string().nullish()
});

export type PublicRequestOutput = z.infer<
    typeof PublicRequestOutputSchema
>;
